import React from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import CustomToolbar from 'components/molecules/CustomToolBarMuiDatatable/CustomToolbarMuiDatatable';
import { Button, Grid } from '@material-ui/core';
import { ICategories } from 'interfaces/imCategories.interface';

interface Props {
  IMCategories: ICategories[];
  isLoading: boolean;
  handleOnClickEditCategory: (wareHouseId: string) => void;
  handleOnClickDeleteCategory: (wareHouseId: string) => void;
  addCategoryButton: () => void;
}
export default function IMCategoriesList({
  IMCategories,
  isLoading,
  handleOnClickEditCategory,
  handleOnClickDeleteCategory,
  addCategoryButton
}: Props) {
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'name',
      label: 'Categoría'
    },
    {
      name: 'isPromotion',
      label: 'Es promoción',
      options: {
        customBodyRender: (value) => {
          if (value) {
            return <div>Sí</div>;
          } else {
            return <div>No</div>;
          }
        }
      }
    },
    {
      name: 'percentage',
      label: 'Porcentaje',
      options: {
        customBodyRender: (value) => <div>{value}%</div>
      }
    },
    {
      name: '',
      label: 'Acciones',
      options: {
        filter: false,
        sort: false,
        download: false,
        print: false,
        empty: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <Grid container justify="flex-start">
              <Button
                variant="outlined"
                size="small"
                color="primary"
                style={{ marginRight: 5 }}
                onClick={() => {
                  handleOnClickEditCategory(tableMeta.rowData[0]);
                }}
              >
                Editar
              </Button>
              <Button
                variant="outlined"
                size="small"
                color="default"
                onClick={() => {
                  handleOnClickDeleteCategory(tableMeta.rowData[0]);
                }}
              >
                Eliminar
              </Button>
            </Grid>
          );
        }
      }
    }
  ];

  const options: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    viewColumns: false,
    searchOpen: true,
    customToolbar: () => {
      return <CustomToolbar tooltip="Agregar categoría" onClick={addCategoryButton} />;
    }
  };

  return (
    <React.Fragment>
      <div>
        <MuiTable
          title="Listado de Categorías"
          isLoading={isLoading}
          columns={columns}
          data={IMCategories}
          options={options}
        />
      </div>
    </React.Fragment>
  );
}
